import { gql, useQuery } from "@apollo/client";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

const Q_GetPublicCertificate = gql`
  query PublicCertificate($uuid: String!) {
    publicCertificate(uuid: $uuid)
  }
`;

function useGetPublicCertificate(uuid, wSO2Token) {
  const { requestBeforeLoginConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetPublicCertificate,
    requestBeforeLoginConfig({
      module: "AVC_AAA",
      variables: {
        uuid: uuid,
      },
      skip: !uuid || !wSO2Token,
    })
  );
  return { data, error, loading, refetch };
}
export default useGetPublicCertificate;
